import { makeFunctionalNext } from '../../definition/resolver';
import { toError, toLoading, toSuccess } from '../../definition/resolverState';
import { RpcError } from './RpcError';
import { Metrics } from '../../../metrics/metrics';
export const fromRPC = ({
  rpc,
  rpcClient
}) => ({
  name: rpc.rpcName,
  tags: ['CHIRP', 'promise'],
  attach: (params, runtime) => {
    const {
      env: {
        logger
      }
    } = runtime;
    const next = makeFunctionalNext(runtime);
    let pendingRefresh = false;
    const guardedFetch = async () => {
      if (pendingRefresh) {
        logger === null || logger === void 0 || logger.debug('refresh already pending');
        return;
      }
      pendingRefresh = true;
      Metrics.counter('resolver-refresh', {
        transport: 'chirp'
      }).increment();
      logger === null || logger === void 0 || logger.debug('fetching');
      const callSiteError = new Error();
      next(toLoading());
      try {
        const result = await rpcClient.callWithResultUnion(rpc, {
          request: params
        });
        if (result.type === 'data') {
          logger === null || logger === void 0 || logger.debug('success');
          next(toSuccess(result.data));
        } else {
          logger === null || logger === void 0 || logger.debug('rpc error');
          next(toError(new RpcError(result.rpcError, callSiteError.stack)));
        }
      } catch (error) {
        logger === null || logger === void 0 || logger.debug('error');
        next(toError(error));
      }
      pendingRefresh = false;
    };
    return {
      refresh: () => void guardedFetch(),
      detach: () => {}
    };
  }
});